$(function () {
    $.validator.setDefaults({
        ignore: puritanLawn.validatorIgnoreRecaptcha,
    });

    // Initialize image button
    $("#imageButton").on("click", function () {
        $("#imageFile").trigger("click");
    });

    // Initialize zip code textbox
    $("#zipCode").on("change", function () {
        var value = $("#zipCode").val();

        if (value === null || value === "") return;

        puritanLawn.ajaxGet(puritanLawn.adminServicesBaseAddress + 'ZipCodeLookup?zipCode=' + value,
            (result) => {
                $("#city").val(result.city);
                $("#state option[value='" + result.stateId + "']").prop('selected', true);
            },
            (response) => {
                alert("error");
            }
        );
    });

    // Initialize search button
    $("#nestedSearchButton").on("click", function () {
        puritanLawn.search.show("Deceased Record Search", (deceasedId, deceasedLFM) => {
            $("#regardingDeceasedId").val(deceasedId);
            $("#regardingDeceasedLFM").val(deceasedLFM);
            $("#regardingDeceasedLFMDisplay").text(deceasedLFM);
        });
    });

    // Initialize image file input
    $("#imageFile").on("change", function () {
        var files = this.files;
        var formData = new FormData();

        for (var i = 0; i < files.length; i++) {
            formData.append('Files', files[i]);
        }

        formData.append('fileType', puritanLawn.fileType.ContactUsImage);

        puritanLawn.ajaxPostMultiPartFormData(puritanLawn.adminServicesBaseAddress + 'UploadFiles',
            formData,
            (results) => {
                var result = results[0];

                $("#image").attr("src", result.url);
                $("#fileName").val(result.name);
                $("#fileUrl").val(result.url);
            },
            (response) => {
                alert("error");
            }
        );
    });
});

var model = null;

function initViewModel(model) {
    // Instantiate view model
    var viewModel = {
        grc: null,
        onSubmit: () => {
            if (puritanLawn.viewModel.grc === null) {
                puritanLawn.showOneButtonModal("Security Check",
                    "Please confirm you are not a robot",
                    "OK");
            }
            else {
                $("#pl-form").submit();
            }
        }
    };

    return viewModel;
}

function recaptcha(token) {
    puritanLawn.viewModel.grc = (token != null);
}